import session from '../../../../share/session';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import { REQUEST_STATUS_COMPLETED, REQUEST_STATUS_FAILED } from '../../../../share/util/api/polling';
import { PHASE } from './constants';
import { stop } from './stop';
import error from '../../../../common/nodejs/errors';

/** 実行処理 */
export async function execute(self) {
  try {
    self.isLoading = true;
    self.isExecuteProcess = true;
    self.phase = PHASE.EXECUTION_MONITORING_STATUS;

    // バックエンドAPI POST,GET
    const token = session.getToken();
    self.executeResponse = await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      {
        id_token: token.id_token,
        type: 'execute'
      },
      // エラー発生のコールバックを実装
      // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
      (errorType) => { errorType; self.showUnexpectedError(); },
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      (result) => { self.validateErrorResult(result); },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      (result) => { self.validateErrorResult(result); },
    );

    self.isExecuteProcess = false;
    // GPF再生中止確認表示が表示中の場合は、その後の処理を実施しない（同画面キャンセル押下時に改めて実行される）
    if (!self.isCancelled) await self.executeHandler();

  } finally {
    // GPF再生中止確認表示が表示中の場合は、スピナー消去しない（_leaveCbエラー回避のため）
    if (!self.isCancelled) self.isLoading = false;
  }
}

/**
 * executeAPIレスポンスに対する処理
 * @param {instance} self 呼び出し元インスタンス
 */
export async function executeHandler(self) {
  try {
    if (!self.executeResponse) return;
    switch (self.executeResponse.data.status) {
      // 正常終了：停止処理へ遷移
      case REQUEST_STATUS_COMPLETED:
        await stop(self);
        break;
      // 異常終了  
      case REQUEST_STATUS_FAILED:
        switch (self.executeResponse.data.async_code) {
          // ルーチン結果確認の値が0x0010,3010,3011：GPF再生異常表示へ遷移
          case error.WSP_008_ROUTINE_RESULT_REGENERATION_ERROR:
            self.gpfErrorTxt = `${self.i18nWsKey}.REQ_WS_8_TXT_15_${self.executeResponse.data.user_data.value}`;
            self.phase = PHASE.GPF_ERROR;
            break;
          // ルーチン結果確認で異常終了 or ルーチン結果確認の値が0x0010,3010,3011以外：通信エラー(処理継続)へ遷移
          case error.WSP_008_ROUTINE_RESULT_FAILED:
            self.phase = PHASE.COMMUNICATION_ERROR;
            break;
          // 上記以外：共通エラーへ遷移  
          default:
            self.showUnexpectedError();
            return;
        }
        break;
      default:
        self.showUnexpectedError();
        return;
    }
  } finally {
    if (!self.isCancelled) self.isLoading = false;
  }
}
